import React from "react";

const Evolution = () => {
  return <div className="modal-down">Evolution</div>;
};

export default Evolution;
